import { QueryCache } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { errorCode, httpStatus } from "@utils/errors";
import { toast } from "@UI/components/Molecules/Notification/toast";
import UnexpectedErrorMessage from "@Core/components/UnexpectedErrorMessage/UnexpectedErrorMessage";
import { hasSilentErrors } from "@Core/queries/silentErrors";

const createAppQueryCache = (
  trackApiError: (status: number | undefined) => void,
) =>
  new QueryCache({
    onError: (error: unknown, query) => {
      if (hasSilentErrors(query.meta)) return;

      console.error(error);

      if (!window.subscriptionOK) return;

      const status = httpStatus(error);

      if (status === 403) {
        window.dispatchEvent(new Event("app:blocked"));
        return;
      }

      if (errorCode(error) === AxiosError.ERR_NETWORK || status === 401) {
        return;
      }

      if (query.meta?.errorHandledLocally !== true) {
        toast.error(<UnexpectedErrorMessage />, { id: "error" });
      }

      trackApiError(status);
    },
  });

export default createAppQueryCache;
